import React from "react";

/**
 * Shared semantic wrapper for every People Intelligence workspace.
 * Phase 1 introduces the module boundary only; workspace content is migrated
 * from MorpheusCountProfiles.jsx in the following phases.
 */
export default function IntelligenceWorkspaceShell({
  workspaceKey,
  eyebrow,
  title,
  description,
  children,
  className = "",
}) {
  const classes = ["mc-intelligenceWorkspace", className].filter(Boolean).join(" ");

  return (
    <section className={classes} data-intelligence-workspace={workspaceKey}>
      {(eyebrow || title || description) ? (
        <header className="mc-intelligenceWorkspace__header">
          {eyebrow ? <span>{eyebrow}</span> : null}
          {title ? <h2>{title}</h2> : null}
          {description ? <p>{description}</p> : null}
        </header>
      ) : null}
      <div className="mc-intelligenceWorkspace__content">{children}</div>
    </section>
  );
}
